/*global define*/
define('src/plugins/plot/src/inspector/PlotEditRegion',[
    './Region'
], function (
    Region
) {

    var PlotEditRegion = new Region({
        name: "plot-options",
        title: "Plot Options",
        modes: ['edit'],
        content: {
            key: "plot-options-edit"
        }
    });

    return PlotEditRegion;
});

